<template>
  <RouterView />
  <Toast position="top-right" />
  <ConfirmDialog />
  <ConfirmDialog group="disclaimer" :style="{ width: '34rem', maxWidth: '92vw' }" />
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
</script>
